import React from 'react';
import Modal from 'react-modal';
import { modalOverlayBackgroundColor, modalStyles } from 'util/constants';
import './GenericModal.scss';
import GenericModalHeader from './GenericModalHeader';
import GenericModalActions, {
  GenericModalActionProps,
} from './GenericModalActions';

interface GenericModalProps {
  actions?: GenericModalActionProps;
  ariaHideApp?: boolean;
  children: React.ReactNode;
  contentLabel?: string;
  isOpen: boolean;
  style?: { overlay?: React.CSSProperties; content?: React.CSSProperties };
  title: string | React.ReactNode;
}

const GenericModal: React.FC<GenericModalProps> = ({
  actions,
  ariaHideApp = false,
  children,
  contentLabel = '',
  isOpen,
  style = {},
  title,
}) => {
  const customModalStyles = {
    overlay: {
      backgroundColor: modalOverlayBackgroundColor,
      ...style.overlay,
    },
    content: {
      ...modalStyles.content,
      padding: 0,
      ...style.content,
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      contentLabel={contentLabel}
      style={customModalStyles}
      ariaHideApp={ariaHideApp}
    >
      <GenericModalHeader title={title} />
      <div className="generic-modal-content">{children}</div>

      {actions && <GenericModalActions {...actions} />}
    </Modal>
  );
};

export default GenericModal;
